import { ArrowR12, ArticleHeading4, UIText2 } from '@cian/ui-kit';
import classNames from 'classnames';
import * as React from 'react';

import { ISuburbanCatalog } from '../../../../../types/suburbanCatalog';
import * as styles from './SuburbanCatalog.css';

type ISuburbanCatalogProps = ISuburbanCatalog;

export const SuburbanCatalog: React.VFC<ISuburbanCatalogProps> = ({ title, description, icon, link, onClick }) => {
  return (
    <a href={link} onClick={onClick} className={styles['container']} target="_blank" rel="noreferrer">
      <div className={classNames(styles['icon'], styles[icon])} />
      <div className={styles['text']}>
        <div className={styles['title']}>
          <ArticleHeading4>{title}</ArticleHeading4>
        </div>
        <UIText2 color="gray60_100">{description}</UIText2>
      </div>
      <div className={styles['arrow']}>
        <ArrowR12 color="primary_100" />
      </div>
    </a>
  );
};
